import React, { useState, useRef, useEffect } from "react";
import CheckIcon from "../assets/images/check.svg";
import { createPortal } from "react-dom";
import BottomSheet from "./BottomSheet";
import useWindowSize from "../../utils/hooks/useWindowSize";

const Dropdown = ({ name, options = [], placeholder, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const dropdownRef = useRef(null);
  const windowSize = useWindowSize();
  const isMobileView = windowSize.x < 950;

  // Toggle dropdown open/close
  const toggleDropdown = () => setIsOpen(!isOpen);

  // Close the dropdown when clicking outside of it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Handle option selection
  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setIsOpen(false); // Close dropdown after selection
    onChange(name, option);
  };

  return (
    <>
      <div
        ref={dropdownRef}
        style={{
          position: "relative",
          width: "100%",
          display: "flex",
          flexDirection: "column"
        }}>
        <div className="dropdown-content" onClick={toggleDropdown}>
          <div
            style={{
              height: 20,
              width: 20,
              borderRadius: "50%",
              border: "1px solid #FFF",
              position: "absolute",
              left: 10,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              transitionDuration: "0.4s",
              backgroundColor: selectedOption ? "#0166EE" : ""
            }}>
            <img
              style={{ opacity: selectedOption ? 1 : 0, transitionDuration: "0.4s" }}
              src={CheckIcon}
            />
          </div>
          <div className="dropdown-text">{selectedOption?.name || placeholder}</div>
        </div>
        <ul
          className="dropdown-menu"
          style={{
            maxHeight: !isMobileView && isOpen ? 200 : 0,
            transition: "max-height 0.4s ease-out",
            overflowY: "auto",
            listStyleType: "none",
            paddingLeft: 5,
            paddingRight: 5,
            backgroundColor: "#DCDCDC99",
            marginLeft: 12,
            marginRight: 12,
            marginTop: 0,
            marginBottom: 4
          }}>
          {options?.map((option, index) => (
            <li
              key={index}
              className="dropdown-list"
              onClick={() => handleOptionClick(option)}
              style={{
                cursor: "pointer",
                fontSize: 14,
                textTransform: "capitalize",
                margin: 2,
                marginTop: 4,
                marginBottom: 4,
                paddingLeft: 10,
                paddingRight: 10,
                paddingTop: 2,
                paddingBottom: 2,
                transitionDuration: "0.4s"
              }}>
              {option.name}
            </li>
          ))}
        </ul>
      </div>
      {isMobileView &&
        createPortal(
          <BottomSheet
            isOpen={isOpen}
            options={options}
            onSelect={handleOptionClick}
            onClose={() => setIsOpen(false)}
          />,
          document.body
        )}
    </>
  );
};

export default Dropdown;
